import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { AddressConfig } from 'src/app/shared/components/address/address-config.model';
import { AddressComponent } from 'src/app/shared/components/address/address.component';
import { Api } from 'src/app/shared/constants/api';

import { DataService } from 'src/app/shared/services/data.service';
import { UtilityService } from 'src/app/shared/services/utility.service';
import { BranchContactComponent } from '../branch-contact/branch-contact.component';
import { DocumentPreviewDialogComponent } from '../document-preview-dialog/document-preview-dialog.component';
import { BranchGstDetailsComponent } from '../branch-gst-details/branch-gst-details.component';
import { ExternalEntityService } from '../external-entity.service';
import * as _ from 'underscore';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { APP_ROUTES } from 'src/app/shared/constants/approutes';
import { DeactivateComponent } from 'src/app/shared/components/deactivate/deactivate.component';
import { ReactivateComponent } from 'src/app/shared/components/reactivate/reactivate.component';
import { ConfirmDailogueComponent } from 'src/app/shared/components/dailogue/confirm-dailogue.component';
import { Observable, ReplaySubject, Subject, Subscription, of } from 'rxjs';
import { catchError, debounceTime, delay, map, switchMap, takeUntil, tap } from 'rxjs/operators';
import { CustomValidator } from 'src/app/shared/validators/custom-validator';
import { KycDetailsComponent } from '../kyc-details/kyc-details.component';
import { PermissionKey } from 'src/app/shared/constants/permissionCode';
import { AuditLogTab, IPermissionWithShow } from 'src/app/shared/interface';
import { Message } from 'src/app/shared/constants/message';
import { PermissionService } from 'src/app/shared/services/permissions.service';
import { KEYS } from 'src/app/shared/constants/keys';

@Component({
    selector: 'app-entity-branch-form',
    templateUrl: './entity-branch-form.component.html',
    styleUrls: ['./entity-branch-form.component.less'],
    standalone: false
})
export class EntityBranchFormComponent implements OnInit, OnChanges, OnDestroy, AfterViewInit {

  @Input() embedded = false;
  @Input() embeddedEntityId: number | null = null;
  @Input() embeddedBranchId: number | null = null;
  @Input() prefillAddress: any = null;

  private _prefillBranchData: any = null;
  private _prefillApplied = false;
  @Input() set prefillBranchData(data: any) {
    if (!data) { return; }
    this._prefillBranchData = data;
  }

  private _entityCreditDefaults: any = null;
  @Input() set entityCreditDefaults(data: any) {
    if (!data) { return; }
    this._entityCreditDefaults = data;
  }

  @Input() customerCreditCurrencyId: number = null;
  @Input() customerCreditCurrencyName: string = null;
  @Input() vendorCreditCurrencyId: number = null;
  @Input() vendorCreditCurrencyName: string = null;

  @Output() branchSaved = new EventEmitter<{id: number}>();
  @Output() headquarterSelected = new EventEmitter<void>();
  @Output() branchCreditAmountChanged = new EventEmitter<void>();

  entityBranchForm:FormGroup;
  addressConfig=new AddressConfig(true,true,true,false,false,true,false,true,false);
  showSEZWefAndUpto:boolean=false;
  id:number;
  branchTypeList: { key: string; label: string }[] = [];
  accessLevelList: { key: string; label: string }[] = [];
  portalColumns = ['userName','emailId','password','accessLevel','isDeactivated','action'];
  countryId:number;
  branchApiData: any = null;
  sharedCompanySegments: any[] = [];
  sharedCurrencyList: any[] = [];
  sharedDialCodesList: { dialCode: string; countryName: string }[] = [];
  businessSegmentList: any[] = [];
  salesPersonList: any[] = [];
  customerSupportList: any[] = [];
  salesPersonSearchCtrl = new FormControl('');
  customerSupportSearchCtrl = new FormControl('');
  filteredSalesPerson: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  filteredCustomerSupport: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  searching = false;
  private _onDestroy = new Subject<void>();
  hideDownload:boolean=true;
  passwordVisible: { [index: number]: boolean } = {};
  formData=new FormData();
  sezDocument:any;
  sezFileName: string = '';
  idToKYC:number;
  responseId:number;
  message:string;
  showDeactivateToggle: boolean = false;
  showReactivateToggle: boolean = false;
  checked:boolean=false;
  @Input() disableSubmit: boolean = false;
  _customerFlag: boolean = false;
  _vendorFlag: boolean = false;
  isEditedData:boolean=false;
  @ViewChild(AddressComponent) addressComponent;
  @ViewChild(BranchContactComponent) contactComponent;
  @ViewChild(BranchGstDetailsComponent) branchGstComponent;
  @ViewChild(KycDetailsComponent) kycDetailsComponent:KycDetailsComponent;
  readonly separatorKeysCodes = [ENTER, COMMA] as const;
  editPermission: boolean = false;
  deactivatePermission: boolean = false;
  reactivatePermission: boolean = false;
	subscription = new Subscription();
  auditLogTabs: AuditLogTab[] = [];

  constructor(private formBuilder:FormBuilder,private utilityService:UtilityService,
              private logger:NGXLogger,private activatedRoute:ActivatedRoute,
              private router:Router,private dailog:MatDialog,private entityService:ExternalEntityService,
              private service:DataService,private permissionService:PermissionService) { }

  ngOnInit(): void {
    this.getAllPermissions();
    this.initializeForm();
    this.setSezChangeValueEvent();
    this.loadDropdowns();
    this.auditLogTabs = [
      { label: 'Branch Details',              icon: 'store',         processData: this.processBranchRecords },
      { label: 'Branch Tax & Credit Details', icon: 'receipt_long', processData: this.processBranchTaxCreditRecords },
      { label: 'Branch Contact',              icon: 'contact_phone', processData: this.processBranchContactRecords },
      { label: 'Branch KYC Details',          icon: 'fact_check',   processData: this.processBranchKycRecords },
    ];

    this.filterSalesPersons();
    this.filterCustomerSupports();
    if (this.embedded) {
      if (this.embeddedEntityId) {
        this.externalEntityId.setValue(this.embeddedEntityId);
        if (!this.embeddedBranchId) {
          if (this._entityCreditDefaults) {
            this._applyEntityCreditDefaults(this._entityCreditDefaults);
          } else {
            this.getEntityById(this.embeddedEntityId);
          }
        }
      }
      if (this.embeddedBranchId) {
        this.id = this.embeddedBranchId;
        this.idToKYC = this.embeddedBranchId;
        if (!this._prefillBranchData) {
          this.getBranchById();
        }
       
      }
    } else {
      this.getParamValue();
      this.activatedRoute.params.subscribe(
        (param:Params) => {
          this.id=+param['branchId'];
          if(!isNaN(this.id))
          {
            this.idToKYC=this.id;
            this.getBranchById();
          }
        }
      );
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['embeddedEntityId'] && this.embeddedEntityId && this.entityBranchForm) {
      this.externalEntityId.setValue(this.embeddedEntityId);
      if (!this.embeddedBranchId) {
        if (this._entityCreditDefaults) {
          this._applyEntityCreditDefaults(this._entityCreditDefaults);
        } else {
          this.getEntityById(this.embeddedEntityId);
        }
      }
    }
    if (changes['embeddedBranchId'] && this.embeddedBranchId && this.entityBranchForm) {
      this.id = this.embeddedBranchId;
      this.idToKYC = this.embeddedBranchId;
      if (!this._prefillBranchData) {
        this.getBranchById();
      }
    }
    // trackBy reuses the Branch 1 component across re-renders, so ngAfterViewInit
    // does not fire again when prefillBranchData arrives after getEntityById returns.
    // Handle it here instead.
    if (changes['prefillBranchData'] && this._prefillBranchData && !this._prefillApplied) {
      this._prefillApplied = true;
      setTimeout(() => this._applyPrefillBranchData(this._prefillBranchData));
    }
    if (changes['prefillAddress'] && !this.embeddedBranchId) {
      const addr = changes['prefillAddress'].currentValue;
      const prev = changes['prefillAddress'].previousValue;
      if (addr && addr.countryId && !(this.addressComponent?.address?.dirty)) {
        const geoChanged = addr.countryId !== prev?.countryId
          || addr.stateId !== prev?.stateId
          || addr.cityId !== prev?.cityId;
        if (geoChanged) {
          setTimeout(() => this.addressComponent?.applyPrefillAddress(addr));
        } else {
          setTimeout(() => this.addressComponent?.address?.patchValue({
            address: addr.address,
            location: addr.location,
            pincode: addr.pincode
          }));
        }
      }
    }
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
    this._onDestroy.next();
    this._onDestroy.complete();
  }

  ngAfterViewInit(): void {
    if (this._prefillBranchData && !this._prefillApplied) {
      this._prefillApplied = true;
      // setTimeout defers past the current CD cycle so patchValue calls in
      // setValueToForm are picked up in the next cycle and rendered immediately.
      // Without this, the form model is updated but the DOM stays blank until
      // the next user interaction triggers change detection.
      setTimeout(() => this._applyPrefillBranchData(this._prefillBranchData));
    }
    // When _prefillBranchData is null, ngOnInit already called getBranchById()
    // (HTTP response fires through Zone.js, so CD runs automatically after it).
  }

  private _applyPrefillBranchData(res: any): void {
    this.getExternalEntityStatus(res);
    this.countryId = res.address?.countryId;
    this.getDocuments(res);
    this.message = this.getStatus(res);
    this.disableForm(res);
    this.setValueToForm(res);
    this.applyReadOnlyState();
    this.branchApiData = res;

    const missingDocs = !res.entityBranchDocuments || res.entityBranchDocuments.length === 0;
    const missingLogins = res.customerPortalLogins == null;
    if ((missingDocs || missingLogins) && this.id) {
      this.service.get(Api.ENTITY_BRANCH + '/' + this.id).subscribe((fullData: any) => {
        if (missingDocs) {
          this.getDocuments(fullData);
        }
        if (missingLogins) {
          this.customerPortalLogins.clear();
          (fullData.customerPortalLogins || []).forEach((login: any) => {
            const form = this.getPortalUserForm();
            form.patchValue({ ...login, password: '' });
            this.customerPortalLogins.push(form);
          });
          if (this.disableSubmit) {
            this.customerPortalLogins.disable({ emitEvent: false });
          }
        }
      });
    }
  }

  private _applyEntityCreditDefaults(data: any): void {
    this.entityBranchForm.patchValue({
      customerFlag: data.customerFlag ?? false,
      vendorFlag: data.vendorFlag ?? false,
      customerCreditDays: data.customerCreditDays ?? null,
      customerCreditAmount: data.customerCreditAmount ?? null,
      vendorCreditDays: data.vendorCreditDays ?? null,
      vendorCreditAmount: data.vendorCreditAmount ?? null
    });
  }

  initializeForm(){
    this.entityBranchForm=this.formBuilder.group({
      id:[],
      code:[null],
      name:[null,[Validators.required,Validators.maxLength(60),Validators.pattern('^[a-zA-Z0-9 ().]+$')]],
      branchType:[null,[Validators.required]],
      externalEntityId:[],
      address:this.utilityService.getAddressForm(),
      sez:[false],
      sezWEFDate:[],
      sezValidUptoDate:[],
      cellNumbers:this.formBuilder.array([]),
      taxDetialsDto:this.entityService.getGSTDetailsForm().get('taxDetialsDto'),
      contactDetailsDto:this.entityService.getContactDetailsForm().get('contactDetailsDto'),
      activeFlag:[],
      status:[],
      submittedForApproval:[],
      customerFlag:this.entityService.getCreditDetailForm().get('customerFlag'),
      customerEntityLevel:this.entityService.getCreditDetailForm().get('customerEntityLevel'),
      customerCreditDays:this.entityService.getCreditDetailForm().get('customerCreditDays'),
      customerCreditAmount:this.entityService.getCreditDetailForm().get('customerCreditAmount'),
      vendorFlag:this.entityService.getCreditDetailForm().get('vendorFlag'),
      vendorEntityLevel:this.entityService.getCreditDetailForm().get('vendorEntityLevel'),
      vendorCreditDays:this.entityService.getCreditDetailForm().get('vendorCreditDays'),
      vendorCreditAmount:this.entityService.getCreditDetailForm().get('vendorCreditAmount'),
      customerApprovalStatus:this.entityService.getCreditDetailForm().get('customerApprovalStatus'),//
      vendorApprovalStatus:this.entityService.getCreditDetailForm().get('vendorApprovalStatus'),//
      customerPortalLogins:this.formBuilder.array([]),
      branchCreditDetails:this.formBuilder.array([]),
      salesMappings:this.formBuilder.array([])
    })
  }

  setSezChangeValueEvent(){
    this.sez.valueChanges.subscribe(sezValue => {
      if(sezValue === true){
        this.showSEZWefAndUpto=true;
        this.sezWEFDate.setValidators([Validators.required]);
        this.sezValidUptoDate.setValidators([Validators.required]);
      } else {
        this.showSEZWefAndUpto=false;
        this.sezWEFDate.clearValidators();
        this.sezWEFDate.reset();
        this.sezValidUptoDate.clearValidators();
        this.sezValidUptoDate.reset();
      }
      this.sezWEFDate.updateValueAndValidity();
      this.sezValidUptoDate.updateValueAndValidity();
    });
  }

  getPortalUserForm(): FormGroup {
    return this.formBuilder.group({
      id:         [null],
      branchId:   [null],
      userName:   ['', [Validators.maxLength(50), Validators.pattern('^[a-zA-Z0-9_]*$')]],
      emailId:    ['', [Validators.email, Validators.maxLength(100)]],
      password:   ['', [Validators.minLength(8),
                        Validators.pattern('(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^a-zA-Z0-9]).{8,}')]],
      accessLevel:   ['READ_ONLY'],
      isDeactivated: [false],
      isDelete:      [false]
    });
  }

  addPortalUser(): void {
    this.customerPortalLogins.push(this.getPortalUserForm());
    this.entityBranchForm.markAsDirty();
  }

  removePortalUser(index: number): void {
    this.customerPortalLogins.removeAt(index);
    this.entityBranchForm.markAsDirty();
  }

  loadDropdowns(): void {
    this.service.get(Api.BRANCH_TYPE_LIST).subscribe(res => {
      this.branchTypeList = res || [];
    });
    this.service.get(Api.BUSINESS_SEGMENT_FOR_DD).subscribe(res => {
      this.businessSegmentList = res || [];
    });
    this.service.get(Api.EMPLOYEE_FOR_DD, { 'active.equals': true, departmentType: 'Sales' }).subscribe(res => {
      this.salesPersonList = res || [];
      this.filteredSalesPerson.next(this.salesPersonList.slice());
    });
    this.service.get(Api.EMPLOYEE_FOR_DD, { 'active.equals': true, departmentType: 'Customer Service' }).subscribe(res => {
      this.customerSupportList = res || [];
      this.filteredCustomerSupport.next(this.customerSupportList.slice());
    });
    const companyId = localStorage.getItem(KEYS.COMPANY_ID);
    if (companyId) {
      this.service.get(`${Api.COMPANY_BUSINESS_SEGMENT_DD}/${companyId}`).subscribe(res => {
        this.sharedCompanySegments = res || [];
      });
    }
    this.service.get(Api.CURRENCY_FOR_DD).subscribe(res => {
      this.sharedCurrencyList = res || [];
    });
    this.service.get(Api.EXTERNAL_ENTITY_DIAL_CODES).subscribe(res => {
      if (res) {
        this.sharedDialCodesList = Object.entries(res).map(([dialCode, countryName]) => ({
          dialCode,
          countryName: countryName as string
        }));
      }
    });
  }

  filterSalesPersons(): void {
    this.salesPersonSearchCtrl.valueChanges.pipe(
      tap(() => this.searching = true),
      takeUntil(this._onDestroy),
      debounceTime(200),
      map(search => {
        if (!this.salesPersonList) { return []; }
        if (!search) { return this.salesPersonList.slice(); }
        return this.salesPersonList.filter(e => e.name.toLowerCase().indexOf(search.toLowerCase()) > -1);
      }),
      delay(200)
    ).subscribe(filtered => {
      this.searching = false;
      this.filteredSalesPerson.next(filtered);
    }, () => { this.searching = false; });
  }

  filterCustomerSupports(): void {
    this.customerSupportSearchCtrl.valueChanges.pipe(
      tap(() => this.searching = true),
      takeUntil(this._onDestroy),
      debounceTime(200),
      map(search => {
        if (!this.customerSupportList) { return []; }
        if (!search) { return this.customerSupportList.slice(); }
        return this.customerSupportList.filter(e => e.name.toLowerCase().indexOf(search.toLowerCase()) > -1);
      }),
      delay(200)
    ).subscribe(filtered => {
      this.searching = false;
      this.filteredCustomerSupport.next(filtered);
    }, () => { this.searching = false; });
  }

  addSalesMapping(): void {
    this.salesMappings.push(this.entityService.salesMappingForm());
    this.salesMappings.at(this.salesMappings.length - 1).get('businessSegmentId').markAsTouched();
    this.entityBranchForm.markAsDirty();
  }

  removeSalesMapping(index: number): void {
    this.salesMappings.removeAt(index);
    this.entityBranchForm.markAsDirty();
  }

  onBusinessSegmentChange(index: number, event: any): void {
    const isDuplicate = this.salesMappings.controls.some((c, i) =>
      i !== index && c.get('businessSegmentId')?.value === event.value
    );
    if (isDuplicate) {
      this.utilityService.notifier(Message.BUSINESS_SEGMENT_DUPLICATE, 'warning');
      this.salesMappings.at(index).get('businessSegmentId').setValue(null);
      this.salesMappings.at(index).get('businessSegmentName').setValue(null);
      return;
    }
    const seg = this.businessSegmentList.find(s => s.id === event.value);
    this.salesMappings.at(index).get('businessSegmentName').setValue(seg ? seg.name : null);
  }

  onSalesPersonChange(index: number, event: any): void {
    const emp = this.salesPersonList.find(e => e.id === event.value);
    this.salesMappings.at(index).get('salesPersonName').setValue(emp ? emp.name : null);
  }

  onCustomerSupportChange(index: number, event: any): void {
    const emp = this.customerSupportList.find(e => e.id === event.value);
    this.salesMappings.at(index).get('customerSupportName').setValue(emp ? emp.name : null);
  }

  onSave(){
    if(this.editPermission){
      if(!this.id){
        this.status='APPROVED';
      }else if(this.id && this.entityBranchForm.get('status').value == 'DRAFT'){
        this.status='APPROVED';
      }
      this.save();
    } else
        this.utilityService.notifier(Message.EDIT_PERMISSION_WARNING,"warning");
  }

  saveForEntity(entityId: number): void {
    this.externalEntityId.setValue(entityId);
    this.status = 'APPROVED';
    this.save();
  }

  saveForEntityAsync(entityId: number, isDraft = false): Observable<any> {
    this.externalEntityId.setValue(entityId);
    this.status = isDraft ? 'DRAFT' : 'APPROVED';

    let formPrepError: any = null;
    try { this.setFormValue(); } catch (e) {
      formPrepError = e;
    }

    const method = this.id ? 'put' : 'post';
    const isHQ = this.entityBranchForm.get('branchType').value === 'HEADQUARTER';
    // In embedded mode the parent entity-form already validates HQ uniqueness in-memory
    // via onHeadquarterSelected(). Querying the backend here would see the stale persisted
    // state (e.g. old HQ branch not yet saved) and falsely block the save.
    const hqCheck$: Observable<boolean> = (isHQ && !this.embedded)
      ? this.service.get(Api.ENTITY_BRANCH_LIST, { entiyId: entityId }).pipe(
          catchError(() => of([])),
          map((branches: any[]) => !(branches || []).some(b => b.branchType === 'HEADQUARTER' && b.id !== this.id))
        )
      : of(true);

    if (formPrepError) {
      this.logger.error('Branch form preparation error', formPrepError);
      return of(null);
    }

    return hqCheck$.pipe(
      switchMap(canSave => {
        if (!canSave) {
          this.utilityService.notifier(Message.HEADQUARTER_ONLY_ONE, 'warning');
          return of(null);
        }
        const branchPayload = { ...this.entityBranchForm.value };
        branchPayload.taxDetails = branchPayload.taxDetialsDto;
        branchPayload.contactDetails = branchPayload.contactDetailsDto;
        delete branchPayload.taxDetialsDto;
        delete branchPayload.contactDetailsDto;
        return this.service[method](Api.ENTITY_BRANCH, branchPayload);
      }),
      tap((response: any) => {
        if (response) {
          this.formData.set('referenceId', response.id);
          this.saveFile();
          this.responseId = response.id;
          if (this.kycDetailsComponent) {
            this.saveKycDocs(this.responseId);
          }
          const branchId = response.id || this.id;
          const hasNewLogins = this.customerPortalLogins.controls.some(c => !c.get('id').value);
          if (branchId && hasNewLogins) {
            this.service.get(Api.ENTITY_BRANCH + '/' + branchId).subscribe((freshData: any) => {
              (freshData.customerPortalLogins || []).forEach((login: any) => {
                const matchCtrl = this.customerPortalLogins.controls.find(c =>
                  c.get('userName').value === login.userName && !c.get('id').value
                );
                if (matchCtrl) {
                  matchCtrl.get('id').setValue(login.id, { emitEvent: false });
                }
              });
            });
          }
          if (this.embedded) {
            this.id = response.id;
            this.entityBranchForm.get('id').setValue(response.id);
            this.entityBranchForm.get('code').setValue(response.code);
            this.branchSaved.emit({ id: response.id });
          }
        }
      }),
      catchError(err => {
        this.logger.error('Branch save failed', err);
        return of(null);
      })
    );
  }

  onBranchTypeChange(value: string): void {
    if (value !== 'HEADQUARTER') return;
    const entityId = this.externalEntityId.value;
    // In embedded mode, branch type changes are in-memory and not yet persisted. Querying the
    // backend would return the old (pre-edit) HQ and falsely block setting another branch as HQ.
    // Delegate to the parent entity-form via the event; it checks in-memory state correctly.
    if (!entityId || this.embedded) {
      this.headquarterSelected.emit();
      return;
    }
    this.service.get(Api.ENTITY_BRANCH_LIST, { entiyId: entityId }).subscribe((branches: any[]) => {
      const existingHQ = (branches || []).find(b => b.branchType === 'HEADQUARTER' && b.id !== this.id);
      if (existingHQ) {
        this.utilityService.notifier(
          Message.HEADQUARTER_BRANCH_IS_SET.replace('{name}', existingHQ.name),
          'warning'
        );
        this.entityBranchForm.get('branchType').setValue(null);
      }
    });
  }

  validateBranch(): boolean {
    this.entityBranchForm.markAllAsTouched();
    this.addressComponent?.address?.markAllAsTouched();
    return this.entityBranchForm.valid
      && (this.addressComponent?.address?.valid ?? true)
      && (this.contactComponent?.validateContacts() ?? true)
      && (this.branchGstComponent?.validateAll() ?? true);
  }

  validateBranchForDraft(): boolean {
    const nameCtrl = this.entityBranchForm.get('name');
    nameCtrl?.markAsTouched();
    return !nameCtrl?.errors;
  }

  save(){
     if (this.embedded && !this.externalEntityId.value) {
       this.utilityService.notifier(Message.SAVE_ENTITY_FIRST, 'warning');
       return;
     }
     if(this.sez.value === true && !this.sezDocument && !this.formData.get('file')){
       this.utilityService.notifier(Message.SEZ_CERTIFICATE_REQUIRED, 'error');
       return;
     }
     this.setFormValue();
     this.entityBranchForm.markAllAsTouched();
     this.addressComponent.address.markAllAsTouched();
     if(this.kycDetailsComponent.areAllMandatoryDocAdded() && this.entityBranchForm.valid && this.addressComponent.address.valid &&
       this.contactComponent.validateContacts()
       && this.branchGstComponent.validateAll())
     {
        const proceed = () => {
          this.isEditedData = true;
          if (this.embedded) {
            this.saveBranch();
          } else {
            this.id ? this.openDailog('Edited Data will be saved Do you wish to continue?') : this.saveBranch();
          }
        };
        const proceedAfterNameCheck = () => {
          if (this.entityBranchForm.get('branchType').value === 'HEADQUARTER') {
            this.validateSingleHeadquarter(proceed);
          } else {
            proceed();
          }
        };
        this.checkBranchNameUnique(proceedAfterNameCheck);
     }
  }

  private checkBranchNameUnique(proceed: () => void): void {
    const entityId = this.externalEntityId.value;
    const branchName = this.name.value?.trim();
    if (!entityId || !branchName) { proceed(); return; }
    this.service.get(Api.ENTITY_BRANCH_LIST, { entiyId: entityId }).subscribe((branches: any[]) => {
      const duplicate = (branches || []).find(b =>
        b.name?.toLowerCase() === branchName.toLowerCase() && b.id !== this.id);
      if (duplicate) {
        this.utilityService.notifier(Message.BRANCH_NAME_NOT_UNIQUE, 'error');
      } else {
        proceed();
      }
    });
  }

  private validateSingleHeadquarter(proceed: () => void) {
    const entityId = this.externalEntityId.value;
    if (!entityId) { proceed(); return; }
    this.service.get(Api.ENTITY_BRANCH_LIST, { entiyId: entityId }).subscribe((branches: any[]) => {
      const otherHQ = (branches || []).find(b => b.branchType === 'HEADQUARTER' && b.id !== this.id);
      if (otherHQ) {
        this.utilityService.notifier(Message.HEADQUARTER_ONE_ALLOWED_WITH_NAME.replace('{name}', otherHQ.name), 'warning');
      } else {
        proceed();
      }
    });
  }

  setFormValue(){
    this.address = this.addressComponent.address.value;
    this.contactDetailsDto.clear();
    this.taxDetialsDto.clear();
    this.contactComponent.branchContactDetailForm.get('contactDetailsDto').value?.forEach(contactObj => {
      const hasData = contactObj.businessSegmentId || contactObj.name?.trim() || contactObj.email?.trim() || contactObj.cellNumber?.trim();
      if(hasData){
      this.contactDetailsDto.push(this.entityService.contactForm(contactObj));}
    });
    this.branchGstComponent.branchTaxDetailForm.get('taxDetialsDto').value?.forEach(taxObj => {
      if(taxObj.gstNo?.length>0){
      this.taxDetialsDto.push(this.entityService.branchTaxForm(taxObj));}
    });
    this.branchCreditDetailsDto.clear();
    const customerCredits = (this.branchGstComponent.branchCreditDetailsForm.get('branchCustomerCreditDetails')?.value || [])
      .map((c: any) => ({ ...c, creditType: 'CUSTOMER' }));
    const vendorCredits = (this.branchGstComponent.branchCreditDetailsForm.get('branchVendorCreditDetails')?.value || [])
      .map((c: any) => ({ ...c, creditType: 'VENDOR' }));
    [...customerCredits, ...vendorCredits].forEach(creditObj => {
      this.branchCreditDetailsDto.push(this.entityService.branchCreditDetailForm(creditObj));
    });
    const validSalesMappings = this.salesMappings.controls.filter(c => c.get('businessSegmentId')?.value);
    this.salesMappings.clear();
    validSalesMappings.forEach(c => this.salesMappings.push(c as FormGroup));
  }

  saveBranch(){
    let method = this.id ? "put" : "post";
    this.service[method](Api.ENTITY_BRANCH, this.entityBranchForm.value).subscribe(
      (response) => {
        this.formData.set('referenceId',response.id);
        this.saveFile();
        this.responseId=response.id;
        this.saveKycDocs(this.responseId);
        this.utilityService.notifier(this.id ? Message.ENTITY_BRANCH_UPDATED : Message.ENTITY_BRANCH_SAVED, 'success');
        // Sync portal login IDs back from the backend — newly created logins get
        // assigned IDs by the DB. Without this, a second save would send id=null
        // and the backend uniqueness check would fail with "Username is already taken".
        const branchId = response.id || this.id;
        const hasNewLogins = this.customerPortalLogins.controls.some(c => !c.get('id').value);
        if (branchId && hasNewLogins) {
          this.service.get(Api.ENTITY_BRANCH + '/' + branchId).subscribe((freshData: any) => {
            (freshData.customerPortalLogins || []).forEach((login: any) => {
              const matchCtrl = this.customerPortalLogins.controls.find(c =>
                c.get('userName').value === login.userName && !c.get('id').value
              );
              if (matchCtrl) {
                matchCtrl.get('id').setValue(login.id, { emitEvent: false });
              }
            });
          });
        }
        if (this.embedded) {
          this.id = response.id;
          this.entityBranchForm.get('id').setValue(response.id);
          this.entityBranchForm.get('code').setValue(response.code);
          this.branchSaved.emit({ id: response.id });
        } else {
          this.navigate();
        }
      }
    );
  }

  trimControl(ctrl: AbstractControl) {
    if (ctrl?.value != null) {
      ctrl.setValue(ctrl.value.trim(), { emitEvent: false });
      ctrl.updateValueAndValidity();
    }
  }

  hasUnsavedChanges(): boolean {
    if (this.entityBranchForm?.dirty) { return true; }
    if (this.addressComponent?.address?.dirty) { return true; }
    if (this.contactComponent?.branchContactDetailForm?.dirty) { return true; }
    if (this.branchGstComponent?.branchTaxDetailForm?.dirty) { return true; }
    if (this.branchGstComponent?.branchCreditDetailsForm?.dirty) { return true; }
    if ((this.kycDetailsComponent?.documents?.length ?? 0) > 0) { return true; }
    return false;
  }

  cancel(){
    if(this.hasUnsavedChanges()) {
      this.isEditedData=false;
      this.openDailog('Edited Data will not get saved Do you wish to continue?');
    }
    else {
      this.navigate();
    }
  }

  navigate(){
    this.activatedRoute.queryParams.subscribe(params => {
      if(params['location']=='edit'){
        this.router.navigate(['../../'],{relativeTo:this.activatedRoute,queryParamsHandling:'preserve'});
      }
      if(params['location']=='list'){
        this.router.navigate(['../../../../'+'branch/'+params['id']],{relativeTo:this.activatedRoute,queryParamsHandling:'preserve'});
      }
      if(params['operation']=='add' && params['id']){
        this.router.navigate(['../'],{relativeTo:this.activatedRoute,queryParams:{'location':'edit'}});
      }
    });
  }

  saveAsDraft(){
     this.status='DRAFT'
     this.save();
  }

  private openDailog(message?:string){
    const dailogRef=this.dailog.open(ConfirmDailogueComponent,{
        data:message,
        maxWidth:"300px",
        maxHeight:"150px"
      });

    dailogRef.afterClosed().subscribe(dailogResult => {
        if(dailogResult===false){
          return;
        }
        else {
          if(!this.isEditedData) {
            this.navigate();
          }
          else {
            this.saveBranch();
          }
        }
    })
  }

  saveKycDocs(id: number): void {
    this.kycDetailsComponent.uploadDocuments(id).subscribe({
      next: (result) => {
        if (result !== null) {
          this.service.put(Api.ENTITY_BRANCH_CAPTURE_DOCUMENT_AUDIT_SNAPSHOT(id), {}).subscribe();
        }
      }
    });
  }

  filesSelected(files){
    if(this.submittedForApproval?.value){ return; }
    const file: File = files[0];
    if(!file){ return; }

    const allowedTypes = ['application/pdf','image/jpeg','image/png'];
    const allowedExt  = /\.(pdf|jpg|jpeg|png)$/i;
    if(!allowedTypes.includes(file.type) && !allowedExt.test(file.name)){
      this.utilityService.notifier(Message.FILE_TYPE_PDF_JPG_PNG, 'error');
      return;
    }
    const maxSize = 5 * 1024 * 1024;
    if(file.size > maxSize){
      this.utilityService.notifier(Message.FILE_SIZE_MAX_5MB, 'error');
      return;
    }

    this.formData.set('file', file);
    this.formData.set('referenceName','Entity Branch');
    this.formData.set('code','12');
    this.formData.set('name','SEZ Certificate');
    this.formData.set('type','SEZ');
    this.sezFileName = file.name;
    this.entityBranchForm.markAsDirty();
  }

  saveFile(){
    if(this.formData.get('file') != null){
      if(this.sezDocument){
        this.formData.set('id', this.sezDocument.id);
      }
      this.utilityService.upload(this.formData).subscribe(response => {
        this.logger.info('SEZ file uploaded successfully');
      });
    }
  }

  downloadFile() {
    const localFile = this.formData.get('file');
    if (localFile instanceof File) {
      this.triggerDocDownload(localFile, localFile.name);
      return;
    }
    if (this.sezDocument) {
      this.service.donwload(this.sezDocument.fileName).subscribe((data: Blob) => {
        if (data) {
          this.triggerDocDownload(data, this.sezDocument.originalFileName || 'document');
        }
      });
    }
  }

  previewSezFile() {
    const localFile = this.formData.get('file');
    if (localFile instanceof File) {
      this.openDocPreview(localFile, localFile.name, localFile.type);
      return;
    }
    if (this.sezDocument) {
      this.service.donwload(this.sezDocument.fileName).subscribe((data: Blob) => {
        if (data) {
          this.openDocPreview(data, this.sezDocument.originalFileName,
            this.getDocMimeType(this.sezDocument.originalFileName));
        }
      });
    }
  }

  private openDocPreview(blob: Blob, fileName: string, contentType: string) {
    const mime = contentType || this.getDocMimeType(fileName);
    const isImage = mime.startsWith('image/');
    const typedBlob = new Blob([blob], { type: mime });
    const url = window.URL.createObjectURL(typedBlob);
    const ref = this.dailog.open(DocumentPreviewDialogComponent, {
      data: { url, fileName, isImage }, maxWidth: '95vw', maxHeight: '95vh'
    });
    ref.afterClosed().subscribe(() => window.URL.revokeObjectURL(url));
  }

  private triggerDocDownload(blob: Blob, fileName: string) {
    const url = window.URL.createObjectURL(blob);
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = fileName || 'document';
    anchor.click();
    window.URL.revokeObjectURL(url);
  }

  private getDocMimeType(fileName: string): string {
    const ext = (fileName || '').split('.').pop()?.toLowerCase();
    switch (ext) {
      case 'png':  return 'image/png';
      case 'jpg':
      case 'jpeg': return 'image/jpeg';
      case 'gif':  return 'image/gif';
      case 'bmp':  return 'image/bmp';
      case 'pdf':  return 'application/pdf';
      default:     return 'application/octet-stream';
    }
  }

  addNumber(event:any){
    const value=(event.value || '').trim();
    if(value.length > 0){
      const allowed = /^[0-9+\-()\s]+$/;
      if(!allowed.test(value)){
        return this.utilityService.notifier(Message.LANDLINE_INVALID_CHARS, 'info');
      }
      if(value.length > 20){
        return this.utilityService.notifier(Message.LANDLINE_MAX_LENGTH, 'info');
      }
      this.cellNumbers.push(this.formBuilder.control(value));
      this.entityBranchForm.markAsDirty();
    }
    if (event.input) {
      event.input.value = '';
    }
  }

  removeNumber(index:number){
    this.cellNumbers.removeAt(index);
    this.entityBranchForm.markAsDirty();
  }

  getNumber(){
    return this.cellNumbers.value;
  }

  openDeactivateForm(e:MatSlideToggleChange){
    if(this.deactivatePermission){
      const data={id:this.id,route:APP_ROUTES.ENTITY_LIST,message:'Entity Branch',api:Api.ENTITY_BRANCH_DEACTIVATE}
      const dailogRef=this.dailog.open(DeactivateComponent,{data:data});
      dailogRef.afterClosed().subscribe(result => {
        if (result !== true) { this.checked = false; }
      });
    } else {
      this.checked = false;
      this.utilityService.notifier(Message.DEACTIVATE_PERMISSION_WARNING,"warning");
    }
  }

  openReactivateForm(e:MatSlideToggleChange){
    if(this.reactivatePermission){
      const data={id:this.id,route:APP_ROUTES.ENTITY_LIST,message:'Entity Branch',api:Api.ENTITY_BRANCH_REACTIVATE}
      const dailogRef=this.dailog.open(ReactivateComponent,{data:data});
      dailogRef.afterClosed().subscribe(result => {
        if (result !== true) { this.checked = false; }
      });
    } else {
      this.checked = false;
      this.utilityService.notifier(Message.ACTIVATE_PERMISSION_WARNING,"warning");
    }
  }


  getBranchById(){
    if(this.id){
      this.service.get(Api.ENTITY_BRANCH+'/'+this.id).subscribe(res => {
        this.getExternalEntityStatus(res);
        this.logger.info('Entity Branch res by id',res);
        this.countryId=res.address?.countryId;
        this.getDocuments(res);
        this.message = this.getStatus(res);
        this.disableForm(res);
        this.setValueToForm(res);
        this.getExternalEntityStatus(res);
        this.applyReadOnlyState();
        this.branchApiData = res;
      });
    }
  }

  private setValueToForm(res: any) {
    res.cellNumbers?.forEach(number => {
      this.cellNumbers.push(this.formBuilder.control(number));
    });
    this.addressComponent.address.patchValue({...res.address, landMarkSet: res.address?.landMarkSet || []});
    this.entityBranchForm.patchValue({
      ...res,
      cellNumbers: res.cellNumbers || [],
      taxDetialsDto: res.taxDetails || res.taxDetialsDto || [],
      contactDetailsDto: res.contactDetails || res.contactDetailsDto || [],
      customerPortalLogins: [],
      salesMappings: res.salesMappings || [],
      branchCreditDetails: res.branchCreditDetails || [],
      address: {
        ...res.address,
        landMarkSet: res.address?.landMarkSet || []
      }
    });
    this.customerPortalLogins.clear();
    res.customerPortalLogins?.forEach((login: any) => {
      const form = this.getPortalUserForm();
      form.patchValue({ ...login, password: '' });
      this.customerPortalLogins.push(form);
    });
    this.salesMappings.clear();
    res.salesMappings?.forEach((m: any) => {
      this.salesMappings.push(this.entityService.salesMappingForm(m));
    });
    this.branchCreditDetailsDto.clear();
    (res.branchCreditDetails || []).forEach((c: any) => {
      this.branchCreditDetailsDto.push(this.entityService.branchCreditDetailForm(c));
    });
  }

  disableForm(res){
    const deactivationPending = res.status === 'APPROVED' && res.submittedForApproval
      && !!res.deactivateDtls?.deactivationWefDate;
    if (this.disableSubmit || res.status == "DEACTIVATED" || (res.submittedForApproval && !deactivationPending)) {
      this.disableSubmit = true;
    }
  }

  private applyReadOnlyState(): void {
    if (!this.disableSubmit) {
      return;
    }
    this.entityBranchForm.disable({ emitEvent: false });
    this.customerPortalLogins.disable({ emitEvent: false });
    this.salesMappings.disable({ emitEvent: false });
    this.addressComponent?.address?.disable({ emitEvent: false });
    this.branchGstComponent?.branchTaxDetailForm?.disable({ emitEvent: false });
    this.branchGstComponent?.branchCreditDetailsForm?.disable({ emitEvent: false });
    this.contactComponent?.branchContactDetailForm?.disable({ emitEvent: false });
    if (this.kycDetailsComponent) { this.kycDetailsComponent.disableTable = true; }
  }

  private getStatus(data: any) {
    if (data.status == "APPROVED" && !data.submittedForApproval) {
      this.showDeactivateToggle=true;
      return null;
    }
    else if (data.status == "DEACTIVATED" && !data.submittedForApproval) {
      this.showReactivateToggle=true;
      return "Deactivated...";
    } else {
      return this.utilityService.getApprovalMessage({status:data.status,
        submittedForApproval: data.submittedForApproval,
        deactivationWefDate: data.deactivateDtls?.deactivationWefDate,
        reactivationWefDate: data.reactivateDtls?.reactivationWefDate});
    }
  }

  private getExternalEntityStatus(data: any){
    this.logger.info("STATUSSS",data.externalEntityStatus);
    if(data.externalEntityStatus == "PENDING" || data.externalEntityStatus == "DEACTIVATED"){
      this.logger.info("STATUSSSSSS",data.externalEntityStatus);
      this.disableSubmit=true;
    }
  }

  getDocuments(res:any){
    const docs = res?.entityBranchDocuments || [];
    this.sezDocument = docs.find((d: any) => d.type === 'SEZ') || _.findWhere(docs, {name: "Sez"});
    if (this.sezDocument) {
      this.sezFileName = this.sezDocument.originalFileName || '';
    }
  }

  getEntityById(id:number){
    this.logger.info('Entity called')
    if(id){
      this.service.get(Api.EXTERNAL_ENTITY+'/'+id).subscribe(res => {
        if (!this.id) {
          this.entityBranchForm.patchValue({
            customerFlag: res.customerFlag ?? false,
            vendorFlag: res.vendorFlag ?? false,
            customerCreditDays: res.customerCreditDays ?? null,
            customerCreditAmount: res.customerCreditAmount ?? null,
            vendorCreditDays: res.vendorCreditDays ?? null,
            vendorCreditAmount: res.vendorCreditAmount ?? null
          });
        }
      });
    }
  }

  getParamValue(){
    this.activatedRoute.queryParams.subscribe(params => {
      if(params['operation']=='add' && params['id']){
        this.externalEntityId.setValue(+params['id']);
        this.getEntityById(+params['id']);
      }
    });
  }

  public getAllPermissions(){
    const permissionCodes=[PermissionKey.ENTITY_BRANCH_EDIT_PERMISSION,PermissionKey.ENTITY_BRANCH_DEACTIVATE_PERMISSION,
        PermissionKey.ENTITY_BRANCH_REACTIVATE_PERMISSION];
    const permissionsWithShowValue:IPermissionWithShow[]=this.permissionService.checkPermissions(permissionCodes,PermissionKey.ENTITY_BRANCH_MODULE);
    this.editPermission=_.findWhere(permissionsWithShowValue,{permissionCode:PermissionKey.ENTITY_BRANCH_EDIT_PERMISSION})?.show?true:false; 
    this.reactivatePermission=_.findWhere(permissionsWithShowValue,{permissionCode:PermissionKey.ENTITY_BRANCH_REACTIVATE_PERMISSION})?.show?true:false; 
    this.deactivatePermission=_.findWhere(permissionsWithShowValue,{permissionCode:PermissionKey.ENTITY_BRANCH_DEACTIVATE_PERMISSION})?.show?true:false; 
  }

  // @EnableAuditLevel(idOnly=true) stores collection fields as flat 2-part keys like
  // "ENTITY_BRANCH.branchCreditDetails" with value "1,2,3" (comma-separated IDs).
  // getAuditPrefix returns '' for 2-part names, so we must also check the last segment.
  private readonly BRANCH_TAX_CREDIT_FLAT = new Set(['branchCreditDetails', 'taxDetails', 'taxDetialsDto']);
  private readonly BRANCH_CONTACT_FLAT     = new Set(['contactDetails', 'contactDetailsDto']);
  private readonly BRANCH_KYC_FLAT         = new Set(['entityBranchDocuments']);
  private readonly BRANCH_EXCLUDED_FLAT    = new Set([
    'branchCreditDetails', 'taxDetails', 'taxDetialsDto',
    'contactDetails', 'contactDetailsDto', 'entityBranchDocuments'
  ]);

  // Field names on the KYC document row that hold the uploaded file itself —
  // shown as Yes/No rather than the raw file name/path.
  private readonly BRANCH_KYC_UPLOAD_FIELDS = new Set<string>(['originalFileName']);

  // Backend-internal fields on DocumentDownloadDTO that must never reach the audit UI.
  private readonly KYC_INTERNAL_FIELDS = new Set(['id', 'referenceId', 'referenceName', 'type']);

  // Pre-translated labels sent by the backend (via audit_property_key) for Tax & Credit tab items.
  private readonly BACKEND_BRANCH_TAX_CREDIT_LABELS = new Set([
    'GST No.', 'GST Description',
    'Business Segment', 'Credit Days', 'Credit Amount', 'Currency'
  ]);

  // Pre-translated labels sent by the backend for Branch Contact tab items.
  private readonly BACKEND_BRANCH_CONTACT_LABELS = new Set([
    'Contact Name', 'Contact Email', 'Contact Mobile',
    'Contact Business Segment', 'Contact Department', 'Contact Designation'
  ]);

  // Human-friendly labels that the backend may have already applied via audit_property_key.
  // Items arriving with these as their propertyName bypass the prefix-based filter.
  private readonly BACKEND_KYC_RENAMED_LABELS = new Set(['Document Code', 'Document Name', 'Upload', 'KYC Done By', 'KYC Date & Time']);

  private readonly BRANCH_KYC_FIELD_LABELS: { [key: string]: string } = {
    documentCode: 'Document Code',
    code: 'Document Code',
    documentName: 'Document Name',
    name: 'Document Name',
    originalFileName: 'File Uploaded',
    uploadedBy: 'KYC Done By',
    uploadedOn: 'KYC Date & Time'
  };

  // Fields that must never appear in any audit tab.
  private readonly AUDIT_HIDDEN_FIELDS = new Set([
    'id', 'activeFlag', 'submittedForApproval',
    'Id', 'Active', 'Submitted for Approval'
  ]);

  private isAuditHidden(propertyName: string): boolean {
    const field = propertyName.split('.').pop() ?? '';
    return this.AUDIT_HIDDEN_FIELDS.has(propertyName) || this.AUDIT_HIDDEN_FIELDS.has(field);
  }

  // Backend sends some sections with propertyName already set to its final human-readable
  // label via audit_property_key (e.g. "GST No."). Those labels can themselves contain a
  // literal period, which the "no dots = already translated" check below can't tell apart
  // from a raw dotted path — checking the known label sets first avoids mangling them
  // (e.g. "GST No." getting chopped at its own period and coming out blank).
  private isBackendPretranslatedLabel(propertyName: string): boolean {
    return this.BACKEND_BRANCH_TAX_CREDIT_LABELS.has(propertyName)
      || this.BACKEND_BRANCH_CONTACT_LABELS.has(propertyName)
      || this.BACKEND_KYC_RENAMED_LABELS.has(propertyName);
  }

  // Returns the label for an audit item — if backend already translated, pass through as-is,
  // otherwise humanize the last field segment of the raw path.
  private getBranchFieldLabel(propertyName: string): string {
    if (this.isBackendPretranslatedLabel(propertyName)) { return propertyName; }
    if (!propertyName.includes('.')) { return propertyName; }
    return this.humanizeAuditField(this.getAuditFieldName(propertyName));
  }

  private isBranchFlatField(propertyName: string, fieldSet: Set<string>): boolean {
    if (!propertyName) { return false; }
    const parts = propertyName.split('.');
    return parts.length === 2 && fieldSet.has(parts[1]);
  }

  // Branch Details excludes: GST (taxDetialsDto/taxDetails), Credit (branchCreditDetails), Contacts, KYC Documents
  processBranchRecords = (items: any[]): any[] => {
    const excludedPrefixes = ['taxDetialsDto', 'taxDetails', 'branchCreditDetails', 'contactDetailsDto', 'contactDetails', 'entityBranchDocuments'];
    return (items || [])
      .filter(item => {
        const pn = item.propertyName;
        if (this.isAuditHidden(pn)) { return false; }
        // Pre-translated by backend — route by label set membership
        if (this.BACKEND_KYC_RENAMED_LABELS.has(pn)) { return false; }
        if (this.BACKEND_BRANCH_TAX_CREDIT_LABELS.has(pn)) { return false; }
        if (this.BACKEND_BRANCH_CONTACT_LABELS.has(pn)) { return false; }
        // Raw-path routing
        const prefix = this.getAuditPrefix(pn);
        if (excludedPrefixes.includes(prefix)) { return false; }
        if (this.isBranchFlatField(pn, this.BRANCH_EXCLUDED_FLAT)) { return false; }
        if (prefix === 'salesMappings') {
          const field = pn.split('.').pop() ?? '';
          if (this.SALES_MAPPING_INTERNAL_FIELDS.has(field)) { return false; }
        }
        return true;
      })
      .map(item => ({ ...item, propertyName: this.getBranchFieldLabel(item.propertyName) }));
  };

  // Branch Tax & Credit Details: both nested (prefix) and flat (idOnly) GST + Credit items
  processBranchTaxCreditRecords = (items: any[]): any[] => {
    const taxCreditPrefixes = ['taxDetialsDto', 'taxDetails', 'branchCreditDetails'];
    return (items || [])
      .filter(item => {
        const pn = item.propertyName;
        if (this.isAuditHidden(pn)) { return false; }
        if (this.BACKEND_BRANCH_TAX_CREDIT_LABELS.has(pn)) { return true; }
        const prefix = this.getAuditPrefix(pn);
        if (prefix !== '') {
          if (!taxCreditPrefixes.includes(prefix)) { return false; }
          const field = pn.split('.').pop() ?? '';
          return !this.CREDIT_INTERNAL_FIELDS.has(field);
        }
        return this.isBranchFlatField(pn, this.BRANCH_TAX_CREDIT_FLAT);
      })
      .map(item => ({ ...item, propertyName: this.getBranchFieldLabel(item.propertyName) }));
  };

  private readonly CREDIT_INTERNAL_FIELDS        = new Set(['branchId', 'businessSegmentId']);
  private readonly SALES_MAPPING_INTERNAL_FIELDS = new Set(['branchId', 'businessSegmentId', 'salesPersonId', 'customerSupportId']);
  private readonly CONTACT_INTERNAL_FIELDS       = new Set(['id', 'entityBranchId', 'entityBranchName', 'businessSegmentId']);

  processBranchContactRecords = (items: any[]): any[] => {
    const contactPrefixes = ['contactDetailsDto', 'contactDetails'];
    return (items || [])
      .filter(item => {
        const pn = item.propertyName;
        if (this.isAuditHidden(pn)) { return false; }
        if (this.BACKEND_BRANCH_CONTACT_LABELS.has(pn)) { return true; }
        const prefix = this.getAuditPrefix(pn);
        if (prefix !== '') {
          if (!contactPrefixes.includes(prefix)) { return false; }
          const parts = pn.split('.');
          return !this.CONTACT_INTERNAL_FIELDS.has(parts[parts.length - 1]);
        }
        return this.isBranchFlatField(pn, this.BRANCH_CONTACT_FLAT);
      })
      .map(item => ({ ...item, propertyName: this.getBranchFieldLabel(item.propertyName) }));
  };

  // Branch KYC Details: document rows added/changed against the branch's KYC checklist.
  // Uploaded-file fields show as Yes/No rather than the raw file name/path.
  processBranchKycRecords = (items: any[]): any[] => {
    return (items || [])
      .filter(item => {
        // If backend already renamed via audit_property_key, accept the item directly.
        if (this.BACKEND_KYC_RENAMED_LABELS.has(item.propertyName)) { return true; }
        const prefix = this.getAuditPrefix(item.propertyName);
        if (prefix !== '') { return prefix === 'entityBranchDocuments'; }
        return this.isBranchFlatField(item.propertyName, this.BRANCH_KYC_FLAT);
      })
      .filter(item => !this.KYC_INTERNAL_FIELDS.has(this.getAuditFieldName(item.propertyName))
                   && this.getAuditFieldName(item.propertyName) !== 'fileName')
      .map(item => {
        // Already renamed by backend — rename 'Upload' to 'File Uploaded' and pass value through.
        if (this.BACKEND_KYC_RENAMED_LABELS.has(item.propertyName)) {
          if (item.propertyName === 'Upload') {
            return { ...item, propertyName: 'File Uploaded' };
          }
          return item;
        }
        const field = this.getAuditFieldName(item.propertyName);
        const isFlat = this.isBranchFlatField(item.propertyName, this.BRANCH_KYC_FLAT);
        const isUploadField = isFlat || this.BRANCH_KYC_UPLOAD_FIELDS.has(field);
        return {
          ...item,
          propertyName: isFlat ? 'File Uploaded' : (this.BRANCH_KYC_FIELD_LABELS[field] || this.humanizeAuditField(field)),
          oldValue: isUploadField ? this.toKycUploadedLabel(item.oldValue) : item.oldValue,
          newValue: isUploadField ? this.toKycUploadedLabel(item.newValue) : item.newValue
        };
      });
  };

  private toKycUploadedLabel(value: any): string {
    if (value === null || value === undefined) { return 'No'; }
    return String(value).trim().length > 0 ? 'Yes' : 'No';
  }

  private filterAuditItemsByPrefix(items: any[], prefixes: string[]): any[] {
    return (items || [])
      .filter(item => prefixes.includes(this.getAuditPrefix(item.propertyName)))
      .map(item => ({ ...item, propertyName: this.humanizeAuditField(this.getAuditFieldName(item.propertyName)) }));
  }

  private filterAuditItemsExcludingPrefix(items: any[], excludedPrefixes: string[]): any[] {
    return (items || [])
      .filter(item => !excludedPrefixes.includes(this.getAuditPrefix(item.propertyName)))
      .map(item => ({ ...item, propertyName: this.humanizeAuditField(this.getAuditFieldName(item.propertyName)) }));
  }

  private getAuditPrefix(propertyName: string): string {
    if (!propertyName) { return ''; }
    const parts = propertyName.split('.');
    // parts[0] is always the referenceType itself (e.g. ENTITY_BRANCH) — the real
    // section name, if this property is nested, is the segment right after it.
    return parts.length > 2 ? parts[1] : '';
  }

  private getAuditFieldName(propertyName: string): string {
    if (!propertyName) { return ''; }
    const parts = propertyName.split('.');
    return parts[parts.length - 1];
  }

  private humanizeAuditField(field: string): string {
    return field
      .replace(/([A-Z])/g, ' $1')
      .replace(/[_.]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim()
      .replace(/\b\w/g, c => c.toUpperCase());
  }

  get code(){return this.entityBranchForm.get('code');}
  get name(){return this.entityBranchForm.get('name');}
  get sezWEFDate(){return this.entityBranchForm.get('sezWEFDate');}
  get sezValidUptoDate(){return this.entityBranchForm.get('sezValidUptoDate');}
  get sez(){return this.entityBranchForm.get('sez');}
  get submittedForApproval(){return this.entityBranchForm.get('submittedForApproval');}
  get cellNumbers(){return (<FormArray>this.entityBranchForm.get('cellNumbers'));}
  get customerPortalLogins(){return (<FormArray>this.entityBranchForm.get('customerPortalLogins'));}
  get contactDetailsDto(){ return (<FormArray>this.entityBranchForm.get('contactDetailsDto'));}
  get taxDetialsDto(){ return (<FormArray>this.entityBranchForm.get('taxDetialsDto'));}
  get branchCreditDetailsDto(){ return (<FormArray>this.entityBranchForm.get('branchCreditDetails'));}

  getCreditDetailsSumByType(): { customer: number; vendor: number } {
    const form = this.branchGstComponent?.branchCreditDetailsForm;
    const customerRows: any[] = form?.get('branchCustomerCreditDetails')?.value || [];
    const vendorRows: any[] = form?.get('branchVendorCreditDetails')?.value || [];
    // fallback: split stored branchCreditDetails by creditType if component form not yet ready
    if (!form) {
      const all: any[] = this.entityBranchForm.get('branchCreditDetails')?.value || [];
      return {
        customer: all.filter(r => r.creditType === 'CUSTOMER').reduce((s, r) => s + (parseFloat(r?.creditAmount) || 0), 0),
        vendor: all.filter(r => r.creditType === 'VENDOR').reduce((s, r) => s + (parseFloat(r?.creditAmount) || 0), 0)
      };
    }
    return {
      customer: customerRows.reduce((s: number, r: any) => s + (parseFloat(r?.creditAmount) || 0), 0),
      vendor: vendorRows.reduce((s: number, r: any) => s + (parseFloat(r?.creditAmount) || 0), 0)
    };
  }
  get salesMappings(){ return (<FormArray>this.entityBranchForm.get('salesMappings'));}
  get externalEntityId(){return this.entityBranchForm.get('externalEntityId');}
  set status(status){ this.entityBranchForm.get('status').setValue(status) };
  set address(address){ this.entityBranchForm.get('address').patchValue(address); }
  get address(){return this.entityBranchForm.get('address'); }
  @Input() set customerFlag(customerFlag){this._customerFlag = !!customerFlag; this.entityBranchForm?.get('customerFlag')?.setValue(customerFlag);}
  set customerEntityLevel(customerEntityLevel){this.entityBranchForm.get('customerEntityLevel').setValue(customerEntityLevel);}
  set customerCreditDays(customerCreditDays){this.entityBranchForm.get('customerCreditDays').setValue(customerCreditDays);}
  set customerCreditAmount(customerCreditAmount){this.entityBranchForm.get('customerCreditAmount').setValue(customerCreditAmount);}
  set customerApprovalStatus(customerApprovalStatus){this.entityBranchForm.get('customerApprovalStatus').setValue(customerApprovalStatus);}//
  @Input() set vendorFlag(vendorFlag){this._vendorFlag = !!vendorFlag; this.entityBranchForm?.get('vendorFlag')?.setValue(vendorFlag);}
  set vendorEntityLevel(vendorEntityLevel){this.entityBranchForm.get('vendorEntityLevel').setValue(vendorEntityLevel);}
  set vendorCreditDays(vendorCreditDays){this.entityBranchForm.get('vendorCreditDays').setValue(vendorCreditDays);}
  set vendorCreditAmount(vendorCreditAmount){this.entityBranchForm.get('vendorCreditAmount').setValue(vendorCreditAmount);}
  set vendorApprovalStatus(vendorApprovalStatus){this.entityBranchForm.get('vendorApprovalStatus').setValue(vendorApprovalStatus);}//
  get branchType(){return this.entityBranchForm.get('branchType');}
}
